import React, { useEffect, useState } from "react";
import { useLoader } from "../../Context/LoaderContext";
import { useNavigate } from "react-router-dom";
import DocContent from "./DocContent";
import useAccess from "../../Hooks/useAccess";
import "./index.scss";

interface Section {
  title: string;
  items: string[];
}

const sections: Section[] = [
  {
    title: "Authentication",
    items: ["Login"],
  },
  {
    title: "Job Posts",
    items: ["Retrieve all job posts", "Retrieve a job post by id"],
  },
  {
    title: "Job Applications",
    items: [
      "Retrieve all job applications",
      "Retrieve a job application by id",
    ],
  },
  {
    title: "Candidates",
    items: ["Retrieve all candidates", "Retrieve a candidate by id"],
  },
];

const ApiDocs: React.FC = () => {
  const { setLoading, setLoadingMessage } = useLoader();
  const { currentPlan, currentLimits } = useAccess();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState<string>(sections[0].items[0]);

  useEffect(() => {
    if (!currentPlan) {
      setLoading(true);
      setLoadingMessage("Loading subscription details...");
    } else if (currentPlan && !currentLimits?.integration) {
      setLoading(false);
      setLoadingMessage(null);
      navigate("/");
    } else {
      setLoading(false);
      setLoadingMessage(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPlan, currentLimits]);

  return (
    <section className="api-docs-container">
      <div className="api-docs-content">
        <div>
          <aside className="docs-sidebar">
            {sections.map((section) => (
              <div key={section.title} className="sidebar-section">
                <h4 className="sidebar-title">{section.title}</h4>

                <ul className="sidebar-list">
                  {section.items.map((item) => (
                    <li
                      key={item}
                      className={`sidebar-item ${
                        activeItem === item ? "active" : ""
                      }`}
                      onClick={() => setActiveItem(item)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </aside>
        </div>

        <div className="api-docs-content-right">
          <DocContent activeItem={activeItem} />
        </div>
      </div>
    </section>
  );
};

export default ApiDocs;
